module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pageContent"
  }, [_c('pageTitle', {
    attrs: {
      "title": "用户中心"
    }
  }), _vm._v(" "), _c('inputBox', {
    attrs: {
      "disabled": true,
      "label": "卡号",
      "value": _vm.g_UserInfo.Card_no
    }
  }), _vm._v(" "), (!_vm.CanChangeName) ? _c('inputBox', {
    attrs: {
      "disabled": true,
      "label": "姓名",
      "value": _vm.UserName,
      "extendType": _vm.IsChange ? "icon" : "",
      "extendSrc": require("../../assets/svg/pen.svg")
    },
    on: {
      "extendHandler": _vm.ChangeName
    }
  }) : _c('inputBox', {
    attrs: {
      "label": "姓名",
      "extendType": "button",
      "extendSrc": _vm.SetName == "" ? "取消" : "保存",
      "hintMsg": "您的新姓名"
    },
    on: {
      "extendHandler": _vm.SaveName
    },
    model: {
      value: (_vm.SetName),
      callback: function($$v) {
        _vm.SetName = $$v
      },
      expression: "SetName"
    }
  }), _vm._v(" "), _c('inputBox', {
    attrs: {
      "disabled": true,
      "label": "性别",
      "value": _vm.g_UserInfo.SexDisplay
    }
  }), _vm._v(" "), _c('inputBox', {
    attrs: {
      "disabled": true,
      "label": "手机",
      "value": _vm.g_UserInfo.sjno,
      "extendType": "icon"
    }
  }), _vm._v(" "), (!_vm.CanChangeCardID) ? _c('inputBox', {
    attrs: {
      "disabled": true,
      "label": "身份证",
      "value": _vm.cardID
    }
  }) : _c('inputBox', {
    attrs: {
      "label": "身份证",
      "extendType": "button",
      "extendSrc": _vm.SetCardID == "" ? "取消" : "保存",
      "hintMsg": "请输入您的身份证号"
    },
    on: {
      "extendHandler": _vm.SaveCardID
    },
    model: {
      value: (_vm.SetCardID),
      callback: function($$v) {
        _vm.SetCardID = $$v
      },
      expression: "SetCardID"
    }
  }), _vm._v(" "), _c('inputBox', {
    attrs: {
      "disabled": true,
      "label": "邮箱",
      "value": _vm.g_UserInfo.Email,
      "extendType": "icon",
      "extendSrc": require("../../assets/svg/pen.svg")
    },
    on: {
      "extendHandler": _vm.changeMail
    }
  }), _vm._v(" "), (_vm.toast) ? _c('mu-toast', {
    attrs: {
      "message": this.TellUser,
      "id": "alertline"
    },
    on: {
      "close": _vm.hideToast
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-61cfcdb0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/BaseInfo.vue
// module id = 1521
// module chunks = 18